export { default as Avatar } from "./Avatar";
export * from "./Avatar";
